"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LandingPageSkeleton = void 0;
var _editorialComponents = require("@ori/editorial-components");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _landingPageClasses = require("../LandingPage/landingPageClasses");
var _styles = require("../LandingPage/styles");
var _constants = require("./constants");
var _styles2 = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Renders Skeleton for `LandingPage`.
 *
 */ const LandingPageSkeleton = (param)=>{
    let { animation = 'pulse', articlesMode = 'featured', className } = param;
    const { getTestId } = (0, _testidGenerator.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Root, {
        className: className,
        "data-testid": getTestId(_constants.LANDING_PAGE_SKELETON),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles2.TopBannerSkeleton, {
                animation: animation,
                className: _landingPageClasses.landingPageClasses.topBanner
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles2.DescriptionSkeleton, {
                animation: animation,
                className: _landingPageClasses.landingPageClasses.description
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_editorialComponents.CategoriesSectionSkeleton, {
                animation: animation,
                className: _landingPageClasses.landingPageClasses.categoriesSection
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_editorialComponents.ArticlesSectionSkeleton, {
                showTitle: true,
                animation: animation,
                mode: articlesMode,
                className: _landingPageClasses.landingPageClasses.articlesSection
            })
        ]
    });
};
exports.LandingPageSkeleton = LandingPageSkeleton;
